import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";

import logo from "../../../../src/assets/substratum-protocol/logo-substratum-protocol.webp";

import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import ModalComponent from "../modal/modal.component";
import ImageComponent from "../image/image.component";
import { useEffect } from "react";
import "./substratum-protocol-styles.scss";

import navigatingGroundShocks from "../../../../src/assets/substratum-protocol/session02/navigating-ground-shocks.webp";
import printingShotgun from "../../../../src/assets/substratum-protocol/session02/burns-prints-shotgun.webp";
import singingShade from "../../../../src/assets/substratum-protocol/session02/singing-shade.webp";
import libraryLattice from "../../../../src/assets/substratum-protocol/session02/library-lattice-portrait.webp";
import superheatedLakeLeviathan from "../../../../src/assets/substratum-protocol/session02/superheatedLakeLeviathan.webp";
import clue11 from "../../../../src/assets/substratum-protocol/session02/anomoly-clue-11.webp";
import clue62 from "../../../../src/assets/substratum-protocol/session02/anomoly-clue-62.webp";
import clue64 from "../../../../src/assets/substratum-protocol/session02/anomoly-clue-64.webp";
import clue43 from "../../../../src/assets/substratum-protocol/session02/anomoly-clue-43.webp";

/*
 * SESSION 02 IMAGES
 *
 * Replace these imports with the actual Session 02 artwork once it has
 * been added to the project's assets.
 *
 * Suggested filenames:
 *
 * import sector03 from "../../../../src/assets/substratum-protocol/session02/sector-03-map-liquefying-crystals.webp";
 * import sector03Scene from "../../../../src/assets/substratum-protocol/session02/sector-03-liquefying-crystals.webp";
 * import starInJar from "../../../../src/assets/substratum-protocol/session02/star-in-the-jar.webp";
 * import singingShade from "../../../../src/assets/substratum-protocol/session02/singing-shade.webp";
 * import libraryLattice from "../../../../src/assets/substratum-protocol/session02/library-lattice.webp";
 * import sector04 from "../../../../src/assets/substratum-protocol/session02/sector-04-map-super-heated-lake.webp";
 * import superHeatedLake from "../../../../src/assets/substratum-protocol/session02/super-heated-lake.webp";
 * import alienInterface from "../../../../src/assets/substratum-protocol/session02/alien-gravity-interface.webp";
 */

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "1",
  marginTop: "20px",
  padding: "15px",
};

const cardStyle = {
  textAlign: "left",
  fontFamily: "Carter One",
  backgroundColor: "rgba(0, 0, 0, 1)",
  color: "white",
  marginBottom: "15px",
};

const SPSession02 = () => {
  const [showModal, setShowModal] = React.useState("");
  const [modalData, setModalData] = React.useState({});

  const handleClick = (img, body) => {
    setModalData({
      body: body,
      image: img,
    });

    handleOpenModal();
  };

  const handleOpenModal = () => {
    setShowModal("show");
  };

  const handleCloseModal = () => {
    setShowModal("");
  };

  const section1Data = [
    {
      title: "",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          <p>
            <h3 style={{ color: "#c47768" }}>
              WARNING: session notes for Substratum Protocol contain spoilers.
              While the envisioning of the sectors, hazards, discoveries, and
              understandings are unique to our group, please do not read if you
              want to encounter the game without any prior knowledge.
            </h3>
          </p>

          <p>
            The expedition enters this session with more questions than answers.
            After their discoveries in the upper sectors of the Fracture, Burns
            and Moshe have begun to suspect that the anomaly is not simply a
            geological or physical phenomenon, but something considerably
            stranger and potentially far older. The ruins they encountered
            appeared to predate humanity, the technology operates according to
            principles beyond anything known, and the mysterious gravitational
            altar suggested that whoever—or whatever—had once occupied these
            depths might have possessed an understanding of the universe that
            humanity can scarcely begin to comprehend.
          </p>
          <p>
            <img
              src={printingShotgun}
              alt="Burns prints multi-shotgun"
              className="imageWrapper"
            />
          </p>
          <p>
            Standing at the mouth of the tunnel filled with the strange
            memory-creation mist, Burns makes a decision that reflects just how
            much the expedition has changed. Whatever lies ahead is dangerous
            enough that scientific equipment alone may not be sufficient. Using
            the exosuit's atomic 3D printer, Burns creates a specialized
            <strong> multi-shotgun</strong>, a weapon capable of switching
            between a close-range scatter-shot configuration and a longer-range
            rifle configuration. It can also alternate between non-lethal rubber
            slugs and traditional ammunition.
          </p>

          <p>
            With the new weapon secured, Burns and Moshe continue their descent
            into <strong>Sector 03</strong>.
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  const section2Data = [
    {
      title: "SECTOR 03: LIQUEFYING CRYSTALS",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          {/*
            <p>
              <img
                src={sector03}
                alt="Sector 03 HUD"
                className="imageWrapper"
              />
            </p>
            */}

          <p>
            Sector 03 is a breathtaking refractory wonderland, filled with
            enormous and intricate formations of multi-colored, liquefied
            crystals. Some formations are small as marbles, while others rise
            like geological towers, their surfaces shifting color and appearing
            almost fluid. The entire chamber possesses an unsettling combination
            of beauty and danger, as though the scientists have entered a vast
            subterranean ecosystem in which the boundaries between rock, liquid,
            heat, and living organisms is blurred. Their first encounter with
            the sector's dangers comes almost immediately when the ground
            beneath them shakes.
          </p>

          <p>
            A tremendous <strong>ground shock</strong> passes through the
            chamber, and the crystal formations around them flex and shift with
            the movement grinding like enormous teeth. Jets of superheated steam
            erupt from cracks and gaps between the crystals. More disturbing
            still, the pressure pulses do not appear random. The tremors and
            releases of steam seem to follow a discernible pattern, suggesting
            that there is some underlying structure to the hazard that might be
            predicted if the scientists can only understand it.
          </p>
          <p>
            <img
              src={navigatingGroundShocks}
              alt="Navigating ground shocks"
              className="imageWrapper"
            />
          </p>
          <p>
            Burns mounts the <strong>Pathfinder Tool</strong> onto BeepBoBop and
            uses the recon drone to help map a route through the shifting
            crystal field, while Moshe assists by running calculations on the
            patterns they are observing. Burns manages to find a viable path.
            The route can be navigated, but there is no single safe path.
            Despite the uncertainty of the route, both scientists successfully
            make it through the hazard without injury.
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  const section3Data = [
    {
      title: "THE CORRIDOR OF REFLECTIONS",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          <p>
            As they move farther into the sector, Burns and Moshe find
            themselves traveling through what appears to be a natural corridor.
            The walls are composed almost entirely of crystal; surfaces
            remarkably smooth and reflective, and the effect is disorienting.
            Their mirrored selves stretch away on both horizons, an endless
            procession of Burns and Moshe marching deeper into the Earth.
          </p>

          <p>
            Their helmet lamps and the exosuit HUDs reflect from the crystalline
            walls until the light becomes almost intolerably intense. The
            scientists struggle to look ahead, and before long both begin to
            cough.
          </p>

          <p>
            Moshe stops to investigate and discovers that they have been exposed
            to a mild parasitic organism carried within vaporized crystal from
            the steam geysers. Moshe also notices something peculiar in one of
            the walls. The reflections seem slightly wrong in an area; what
            initially appears to be a solid crystal surface is concealing a
            small alcove.
          </p>

          <p>
            Moshe reaches inside and discovers a <strong>specimen jar</strong>
            resting on a trivet. The trivet is engraved with strange glyphs and
            pictographs that clearly do not originate from any known human
            culture. Inside the jar is a brilliant sphere of energy and light
            that appears to be almost impossibly dense.
          </p>

          <p>
            Further examination through the exosuit's computer systems produces
            a result that neither scientist is prepared to accept.
          </p>

          <p>
            The jar contains a <strong>star</strong>.
          </p>
          <p>
            <img
              src={clue62}
              alt="Clue 62: The Star in the Jar"
              className="imageWrapper"
            />
          </p>
          <p>
            It is not a miniature representation of a star, a holographic image,
            or some unknown mineral emitting light. The instruments indicate
            that the sphere is an actual star compressed and suspended inside a
            container roughly the size of a large mason jar.
          </p>

          <p>
            The database cross-reference makes the discovery even more
            impossible.
          </p>

          <p>
            The star is identified as <strong>Alpha Centauri A</strong>, also
            known as <strong>Rigil Kentaurus</strong>, a yellow-dwarf star
            similar in type and mass to Earth's Sun.
          </p>

          <p>
            The scientists are left staring at an object that should be
            thousands of times larger than the Earth, somehow contained within a
            small specimen vessel in a hidden alcove beneath the planet's
            surface.
          </p>

          <p>
            The earlier discovery of the gravitational altar takes on a new
            significance. Burns and Moshe wonder whether the structures they
            have encountered are not isolated curiosities at all, but fragments
            of a much larger system created by an unknown alien civilization. If
            someone has possessed the technology to capture and contain a star,
            then theories that would previously have sounded like ridiculous
            pulp science fiction now seem plausible.
          </p>

          <p>
            Perhaps planets have been harvested. Maybe gravity itself has been
            manipulated. Could it be the Earth is not simply being torn apart by
            an anomaly; that the anomaly is part of a machine? And perhaps that
            machine has been operating for longer than human civilization has
            existed.
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  const section4Data = [
    {
      title: "THE SINGING SHADE",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          <p>
            Burns and Moshe continue deeper into Sector 03, moving through an
            increasingly colorful region where the crystal formations are
            multi-hued, and bioluminescent plants twinkle among their facets.
            Then the fungi release an enormous cloud of hallucinogenic gas; the
            cloud rolls through the cavern and begins creeping into the
            scientists' exosuits.
          </p>

          <p>
            Burns experiences the effects first as a vivid memory. He remembers
            his mother baking bread, including the smell of the loaf as it cooks
            in the oven. He remembers opening the oven door and looking inside.
            There is an infant in the oven with enormous black eyes.
          </p>

          <p>
            Burns blinks violently, and the vision disappears. He immediately
            realizes it is a hallucination, not a memory. The nano-spores in the
            atmosphere have interfered with his mind and created something that
            feels like a genuine recollection despite never having happened.
          </p>

          <p>
            Moshe is affected by the gas as well. Rather than seeing a false
            memory, Moshe sees what appears to be the future. Five minutes from
            that moment, he sees a star similar to the one they discovered in
            the specimen jar shoot upward into the ceiling of the cavern,
            illuminating the path ahead. The vision is so specific that Moshe
            cannot simply dismiss it. If the gas can create false memories,
            could it also create convincing predictions? Or has the anomaly
            somehow allowed Moshe to perceive something that has not yet
            happened?
          </p>

          <p>
            Moshe decides to study the gas, but his attempt quickly becomes
            complicated by another discovery. Among the crystals and mushrooms
            is a beautiful little plant covered in multi-colored flowers. Moshe
            touches one of the flowers, and it produces a clear musical tone.
            Each flower responds differently, producing its own distinct note
            according to its color.
          </p>
          <p>
            <img
              src={singingShade}
              alt="Singing Shade"
              className="imageWrapper"
            />
          </p>
          <p>
            The scientists have encountered a <strong>Singing Shade</strong>, a
            remarkable plant whose individual flowers produce unique colors and
            sounds when touched. There are hints that an entire discipline of
            study may exist around the relationship between color and sound.
          </p>

          <p>
            Moshe tries to understand the plant and determine what mechanism
            allows it to translate color into sound, but the hallucinogenic
            effects of the gas make the task nearly impossible. The flowers
            eventually retract into the plant, almost like a turtle pulling its
            head into its shell, leaving Moshe with no answers. The failure
            weighs heavily on him. Between the uncertainty surrounding his
            vision of the future, the effects of the gas, and his inability to
            decode the Singing Shade, Moshe suffers Stress damage.
          </p>

          <p>
            Burns continues investigating the hallucinogenic environment when he
            kneels near the base of a gray crystal and notices something else
            that does not belong. There are <strong>alien sigils</strong> carved
            into a nearby rock. And lying beside them is a{" "}
            <strong>four-foot-long feather coated in fresh blood</strong>.
          </p>
          <p>
            <img src={clue64} alt="Bloody feather" className="imageWrapper" />
          </p>
          <p>
            Burns immediately begins speculating about its origin. He wonders
            whether it might have come from a prehistoric dinosaur, but the
            blood is clearly not human, and whatever creature produced the
            feather appears to still be alive—or has at least been alive very
            recently.
          </p>

          <p>
            The thought leads Burns down an increasingly strange path. Perhaps
            dinosaurs were seeded on Earth by an alien civilization. Perhaps
            some of the feathered dinosaurs of Earth's distant past were not
            entirely natural at all. Maybe they even served as domesticated
            animals or mounts for the beings who created the structures beneath
            the planet.
          </p>

          <p>
            Realizing that he is beginning to follow the hallucinations and the
            atmosphere's influence rather than evidence, Burns shakes himself
            back to reality and decides that they need to leave the gas cloud
            before their theories become even more detached from reality. He
            helps the increasingly devastated Moshe to his feet, and together
            they continue through the liquefying crystals.
          </p>

          <p>
            Yet Burns carries one final thought with him as they leave the
            hallucinogenic fog behind: what if the Fracture is not an accident?
            What if all of these discoveries—the ruins, the creatures, the
            gravitational technology, the strange energies, and the anomaly
            itself—are components of a plan conceived by an alien intelligence
            that has been unfolding for eons?
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  const section5Data = [
    {
      title: "THE LIBRARY LATTICE",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          <p>
            Eventually the scientists emerge from the fungal gas and find the
            entrance to another tunnel, this one almost completely covered by a
            twisting latticework of vines. The growth appears to be ordinary
            subterranean vegetation, then the vines begin to pulse with light.
          </p>

          <p>
            Within the gaps of the tangled latticework, images appear like
            holographic projections. Burns and Moshe see strange landscapes and
            unfamiliar creatures, but they also see mundane scenes from Earth,
            including recognizable cities and environments that should have no
            reason to exist in the depths of the planet.
          </p>

          <p>
            The scientists realize they have discovered a
            <strong> Library Lattice</strong>, an information repository woven
            into living plant matter. The lattice appears to contain a vast
            visual history, preserving images of places, creatures, and events
            within its living structure.
          </p>
          <p>
            <img
              src={libraryLattice}
              alt="Library Lattice"
              className="imageWrapper"
            />
          </p>
          <p>
            This particular lattice appears to be something even more
            significant. Its images seem to encompass information far beyond the
            immediate cavern, showing places and creatures the scientists cannot
            identify and suggesting that the lattice might somehow function as
            an information hub connected to the wider systems operating
            throughout the Fracture.
          </p>

          <p>
            Before attempting to study it, Moshe uses the exosuit's
            <strong> Systems Upgrade</strong> capability. The upgrade
            dramatically restores his condition. His Stress is cleared, his
            Skills return to their maximum values, and his capacity for THINK
            increases to a powerful <strong>d12</strong>, leaving him better
            equipped than ever to confront whatever information the lattice
            contains.
          </p>

          <p>
            With his systems restored, Moshe examines the Library Lattice again.
          </p>

          <p>The result is extraordinary.</p>

          <p>
            One by one, the images disappear. Everything that had been displayed
            across the vines fades until only a single image remains in the
            center.
          </p>

          <p>
            It appears to be an <strong>alien door</strong>.
          </p>

          <p>Or perhaps a portal.</p>

          <p>
            At its center is an enormous eye, and the eye appears to be looking
            directly at Moshe.
          </p>
          <p>
            <img src={clue11} alt="Eye Portal" className="imageWrapper" />
          </p>
          <p>
            The scientists develop a theory. It could be that the portal is not
            a doorway in the conventional sense, but a representation of an
            alien computer or interface. Perhaps the intelligence behind the
            Fracture understands the universe primarily through observation,
            using something like a vast sensory organ to perceive reality and
            transmit that information into a deeper, centralized alien
            consciousness.
          </p>

          <p>
            They cannot prove any of it, but then the portal fades and the
            lattice opens. Burns and Moshe step through the now dormant Library
            Lattice and emerge in
            <strong> Sector 04</strong>.
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  const section6Data = [
    {
      title: "SECTOR 04: THE SUPER-HEATED LAKE",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          <p>
            The new sector is a sprawling super-chamber dominated by a gigantic
            underground lake. The water is perfectly clear, but its temperature
            is dangerously high, and the lake teems with life. Numerous islands
            and pathways of solid ground extend throughout the chamber, while
            bioluminescent plants illuminate the surrounding environment with
            strange colors.
          </p>

          <p>
            For a brief moment, the scientists simply stand at the shore and
            observe. Then a crest appears in the water. Something enormous is
            moving beneath the surface. A massive creature breaches the lake
            surface.
          </p>

          <p>
            The behemoth is roughly the size of a whale, and its back is covered
            in jagged crystalline formations that make the animal appear almost
            like a living geological structure. It swims directly toward the
            shore where Burns and Moshe stand waiting.
          </p>
          <p>
            <img
              src={superheatedLakeLeviathan}
              alt="Super-heated lake leviathan"
              className="imageWrapper"
            />
          </p>
          <p>
            Burns watches the creature's wake carefully. Something about the
            water movement seems unusual. The patterns are not simply the result
            of the creature's body passing through the lake. There is an
            additional rhythm to the movement, almost as though the creature is
            deliberately manipulating the water. Burns deploys the expedition's
            sensors. The results are remarkable: The creature is{" "}
            <strong>sentient</strong> and capable of communication.
          </p>

          <p>
            Burns attempts to communicate with it and succeeds. The creature is,
            in fact, a whale—although it belongs to a species unknown to Earth's
            surface oceans. It has lived within the super-heated lakes of Sector
            04 for hundreds of years, and the jagged crystals covering its back
            are not natural armor but the accumulated minerals and microscopic
            lifeforms that have built up on its body over its extraordinarily
            long life.
          </p>

          <p>
            The whale does not understand the anomaly itself, but it understands
            that something is wrong. The anomaly is disturbing its habitat, and
            the creature is afraid. More importantly, it has found something
            that it wants to show the scientists.
          </p>

          <p>
            It swims closer to the shore and guides Burns and Moshe toward an
            area near the edge of the lake where strange holographic shapes hang
            suspended in the air.
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  const section7Data = [
    {
      title: "THE GRAVITATIONAL INTERFACE",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          <p>
            The holographic shapes resemble the alien pictographs and symbols
            that Burns and Moshe have encountered throughout their journey, but
            these are different from the static markings carved into rocks and
            structures. They are interactive.
          </p>
          <p>
            <img
              src={clue43}
              alt="Holographic computer interface pictographs"
              class="imageWrapper"
            />
          </p>
          <p>
            The scientists can see that they are looking at a computer
            interface, although calling it a "computer" may already be imposing
            too much of humanity's understanding onto a technology that operates
            according to principles they do not yet understand.
          </p>

          <p>
            Burns attempts to study the system. He fails, but his failure
            produces an unexpected <strong>Flashback</strong>, and Burns finds
            himself remembering an earlier deep-water study. He remembers charts
            depicting water movement, the interaction of currents, and the way
            colliding flows can combine to create entirely new pathways in the
            water. Looking at the holographic shapes again, he recognizes the
            alien controls behave like <strong>water currents</strong>.
          </p>

          <p>
            The shapes can be moved, combined, redirected, and arranged in
            patterns resembling the flow dynamics he spent his career studying
            as a hydrologist.
          </p>

          <p>
            His professional knowledge has given him a way into the alien
            system, but the discovery immediately generates a much larger
            question.
          </p>

          <p>What if the patterns are not actually describing water?</p>

          <p>
            It seems possible an alien civilization or power has learned to
            manipulate
            <strong> gravity</strong> in a way that humanity manipulates fluids,
            directing gravity into currents that produce energy structures,
            images, or even physical manifestations.
          </p>

          <p>
            The possibility is almost impossible to comprehend. But after
            finding a known star in a specimen jar, the boundaries of
            possibility are themselves becoming fluid.
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  useEffect(() => {
    document.body.style.backgroundColor = "#c47768";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "IM Fell Great Primer",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <a name="pageTop" href="#pageTop">
                  <img
                    src={logo}
                    style={{
                      maxWidth: "400px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                    }}
                    alt="Substratum Protocol campaign"
                  />
                </a>
              </main>

              <h1 className="cover-heading">THE STAR IN THE JAR</h1>

              <h4>Substratum Protocol Session 02</h4>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card style={cardStyle}>
            <Card.Body>
              <Card.Title
                id="cardTitle-substratum-protocol"
                className="cardTitle-substratum-protocol"
              >
                <span
                  style={{
                    color: "black",
                    textAlign: "center",
                  }}
                >
                  Burns and Moshe descend through the liquefying crystals of
                  Sector 03, uncover a star contained in a jar, encounter a
                  living information network, and discover a possible alien
                  technology for manipulating gravity.
                </span>
                <br />
                <small>
                  <span className="emoji" role="img" aria-label="lab coat">
                    🥼
                  </span>
                  <a href="./substratum-protocol-scientist-profile-moshe-mazel">
                    Dr. Moshe Mazel
                  </a>
                  <span className="emoji" role="img" aria-label="lab coat">
                    🥼
                  </span>
                  <a href="./substratum-protocol-scientist-profile-burnstein-grok">
                    Dr. Burnstein Grok
                  </a>
                  <br />
                  <span className="emoji" role="img" aria-label="earth">
                    🌎
                  </span>
                  <a href="./substratum-protocol-session-01">
                    Session 01: The Earth is Breaking
                  </a>
                  <span className="emoji" role="img" aria-label="crystal">
                    💎
                  </span>
                  Session 02: The Star in the Jar
                  <span className="emoji" role="img" aria-label="crystal">
                    💎
                  </span>
                  <a href="./substratum-protocol-session-03">
                    Session 03: The Gravity of Darkness
                  </a>
                </small>
              </Card.Title>

              <div>
                <ContentContainer data={section1Data} />
              </div>

              <div>
                <ContentContainer data={section2Data} />
              </div>

              <div>
                <ContentContainer data={section3Data} />
              </div>

              <div>
                <ContentContainer data={section4Data} />
              </div>

              <div>
                <ContentContainer data={section5Data} />
              </div>

              <div>
                <ContentContainer data={section6Data} />
              </div>

              <div>
                <ContentContainer data={section7Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SPSession02;
